import React from 'react'
import {
  AutocompleteArrayInput,
  AutocompleteArrayInputProps,
} from 'react-admin'
import { Customer } from 'services/api/entities/crm/pmi'
import { useKGetList } from 'services/hooks/useKGetList'
import KToolTip from 'ui-shared/KTooltip'

const ClientAutocompleteArrayInput: React.FC<AutocompleteArrayInputProps> = (
  props
) => {
  const pmi = useKGetList<Customer>('pmi')

  return (
    <KToolTip title="form.fields.tailoredClientTooltip" placement="top-start">
      <AutocompleteArrayInput
        {...props}
        source="customers"
        choices={pmi.map((e) => ({
          id: e.id,
          name: `${e.email} - ${e.name}`,
        }))}
      />
    </KToolTip>
  )
}

export default ClientAutocompleteArrayInput
